<template>
  <div class="flex flex-col gap-8">
    <Heading
      v-if="headline.text"
      color="blue"
      weight="normal"
      class="no-container-page-offset"
      :tag="headline?.tag ?? 'h2'"
    >
      {{ headline.text }}
    </Heading>
    <EditableArea :content="main" :custom-view="SliderArea" class="story-slider" />
  </div>
</template>

<script setup>
import useNavigationTracking, {
  NAVIGATION_SLIDER_STORY,
} from "~/composables/tracking/useNavigationTracking";
import { EditableArea } from "@magnolia/vue-editor";
import SliderArea from "../../areas/SliderArea";
import { screens } from "~/tailwind.config.screens";
import { Heading } from "~/components/clarity-ui/Heading";

useNavigationTracking(NAVIGATION_SLIDER_STORY);

defineProps(["main", "headline"]);

provide("swiperOptions", {
  slidesPerView: 1.2,
  spaceBetween: 8,
  centeredSlides: false,
  loop: false,
  breakpoints: {
    // when window width is >= 320px
    [parseInt(screens.md)]: {
      slidesPerView: 2.4,
      spaceBetween: 16,
    },
    // when window width is >= 480px
    [parseInt(screens.xl)]: {
      slidesPerView: 3,
      spaceBetween: 24,
    },
  },
});
</script>

<style>
.story-slider .swiper .swiper-slide {
  @apply h-auto;
  max-width: calc((10 / 12) * 100% + 8px);
  @screen md {
    max-width: calc((5 / 12) * 100% + 16px);
  }
  @screen xl {
    max-width: calc((4 / 12) * 100% + 24px);
  }
}
</style>
